//====================================================
//  Initialization Aos
//  (data-aos="fade-in" data-aos-delay="300" data-aos-once="true" data-aos-duration="700")
//====================================================
function fn_components_aos(){
	AOS.init();
}
